// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.personalization-accordion-button {
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}

.personalization-accordion {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.accordion-button:not(.collapsed) {
  color: var(--dark-blue-title) !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  background-color: transparent !important;
}

.accordion-button:focus {
  box-shadow: none !important;
}

.accordion-button:not(.collapsed) {
  box-shadow: none !important;
}

.accordion-button {
  color: var(--dark-blue-title) !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  width: 100% !important;
  padding-left: 0px !important;
}

.accordion-header button {
  bottom: 0px !important;
}

.accordion-item {
  border: none !important;
  border-bottom: 1px solid var(--disabled-link) !important;
  color: var(--dark-blue-title) !important;
}

.accordion-body {
  padding: 0px !important;
}

.accordion-item:last-of-type {
  border-bottom-right-radius: unset !important;
  border-bottom-left-radius: unset !important;
}

.last-accordion {
  border-bottom: transparent !important;
}`, "",{"version":3,"sources":["webpack://./src/infraestructure/styles/accordion.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;EACA,0CAAA;AACF;;AAEA;EACE,gEAAA;AACF;;AAEA;EACE,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wCAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;AACF;;AAGE;EACE,sBAAA;AAAJ;;AAIA;EACE,uBAAA;EACA,wDAAA;EACA,wCAAA;AADF;;AAIA;EACE,uBAAA;AADF;;AAIA;EACE,4CAAA;EACA,2CAAA;AADF;;AAIA;EACE,qCAAA;AADF","sourcesContent":[".personalization-accordion-button {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\n  font-size: 1rem;\n  color: var(--bs-accordion-btn-color);\n  text-align: left;\n  background-color: var(--bs-accordion-btn-bg);\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: var(--bs-accordion-transition);\n}\n\n.personalization-accordion {\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.accordion-button:not(.collapsed) {\n  color: var(--dark-blue-title) !important;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  background-color: transparent !important;\n}\n\n.accordion-button:focus {\n  box-shadow: none !important;\n}\n\n.accordion-button:not(.collapsed) {\n  box-shadow: none !important;\n}\n\n.accordion-button {\n  color: var(--dark-blue-title) !important;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  width: 100% !important;\n  padding-left: 0px !important;\n}\n\n.accordion-header {\n  button {\n    bottom: 0px !important;\n  }\n}\n\n.accordion-item {\n  border: none !important;\n  border-bottom: 1px solid var(--disabled-link) !important;\n  color: var( --dark-blue-title) !important;\n}\n\n.accordion-body {\n  padding: 0px !important;\n}\n\n.accordion-item:last-of-type {\n  border-bottom-right-radius: unset !important;\n  border-bottom-left-radius: unset !important;\n}\n\n.last-accordion {\n  border-bottom: transparent !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
